import React from 'react'
import Pinteg from '../../../components/Pinteg'
import Stories from '../../../components/Stories'
import Cure from '../../../components/Cure'

const DebtStatusPage = () => {
    return (
        <Pinteg>
            <Stories />

            <Cure />
        </Pinteg>
    )
}

export default DebtStatusPage
